import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { EventManager } from 'src/app/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss']
})
export class SearchFilterComponent implements OnInit, OnDestroy {
  @Input() isSearch = true;
  @Input() total;
  @Output() search$: EventEmitter<string> = new EventEmitter();
  subscribes: Subscription[];
  params: any = {};
  constructor(
    public eventManager: EventManager
  ) {

  }
  ngOnInit() {
    this.subscribes = [...[
      this.eventManager.subscribe(('add-option-search'), (res) => {
        this.addOption(res.content);
      }),
      this.eventManager.subscribe(('get-value-search'), (res) => {
        this.search();
      }),
    ]];
  }
  ngOnDestroy() {
    this.subscribes.forEach((sub) => sub.unsubscribe());
  }
  addOption(object) {
    this.params[object.key] = object.value;
  }
  search() {
    this.search$.emit(this.params);
  }
}
